import React from 'react';

export interface ColumnResizeHandleProps {
  columnKey: string;
  onResizeStart: (e: React.MouseEvent, columnKey: string) => void;
}

export function ColumnResizeHandle({ columnKey, onResizeStart }: ColumnResizeHandleProps) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={`Resize ${columnKey} column`}
      className="absolute top-0 right-0 h-full w-1 cursor-col-resize select-none hover:bg-primary/50"
      onMouseDown={(e) => onResizeStart(e, columnKey)}
    />
  );
}
